import { type FC, type PropsWithChildren } from "react";
import { CssBaseline } from "@mui/material";
import { ThemeProvider as ThemeClientProvider } from "@mui/material/styles";
import { createTheme } from "@/shared/utils/createTheme";

export const ThemeProvider: FC<PropsWithChildren> = ({ children }) => {
  const theme = createTheme("dark");

  return (
    <ThemeClientProvider theme={theme}>
      <CssBaseline />

      {children}
    </ThemeClientProvider>
  );
};
